export const getAll = () => groq`*[_type == 'banners'][0]`
